import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

/** A read-only macro the server shares with every provider in a specialty. */
export interface SharedMacro {
  dot_phrase: string;
  keywords: string[];
  content: string;
}

export const sharedMacrosKeys = {
  all: ["sharedMacros"] as const,
};

const EMPTY_SHARED_MACROS: SharedMacro[] = [];

export function useSharedMacrosQuery(): SharedMacro[] {
  const query = useQuery<SharedMacro[]>({
    queryKey: sharedMacrosKeys.all,
    queryFn: () => api.get<SharedMacro[]>("/macros/shared"),
    staleTime: Infinity,
  });

  return query.data ?? EMPTY_SHARED_MACROS;
}
